module.exports = __webpack_public_path__ + "static/img/design-samsung.a9be66a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/design-samsung.jpg
// module id = isOC
// module chunks = 0